// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./components/feature-badge/feature-badge.component.scss
// module id = 61
// module chunks = 0